import { Controller } from "@hotwired/stimulus"
import hljs from "highlight.js/lib/core"
import javascript from "highlight.js/lib/languages/javascript"
import typescript from "highlight.js/lib/languages/typescript"
import php from "highlight.js/lib/languages/php"
import ruby from "highlight.js/lib/languages/ruby"
import xml from "highlight.js/lib/languages/xml"
import css from "highlight.js/lib/languages/css"
import json from "highlight.js/lib/languages/json"
import bash from "highlight.js/lib/languages/bash"
import sql from "highlight.js/lib/languages/sql"
import yaml from "highlight.js/lib/languages/yaml"
import python from "highlight.js/lib/languages/python"

const LANGS = { javascript, typescript, php, ruby, xml, css, json, bash, sql, yaml, python }
Object.entries(LANGS).forEach(([name, lang]) => hljs.registerLanguage(name, lang))
hljs.registerAliases(["js"], { languageName: "javascript" })
hljs.registerAliases(["ts"], { languageName: "typescript" })
hljs.registerAliases(["html"], { languageName: "xml" })
hljs.registerAliases(["rb"], { languageName: "ruby" })
hljs.registerAliases(["sh"], { languageName: "bash" })
hljs.registerAliases(["yml"], { languageName: "yaml" })
hljs.registerAliases(["py"], { languageName: "python" })

// Colorea los bloques de código guardados al mostrar un documento.
export default class extends Controller {
  connect() {
    this.element.querySelectorAll("pre code").forEach((el) => {
      delete el.dataset.highlighted
      try { hljs.highlightElement(el) } catch (e) { /* lenguaje desconocido */ }
    })
  }
}
